import {
  curry,
} from '@/utils/lodash';

import errorUtils from './error-utils';
import httpUtils from './external-modules/http-utils';

const routesToIgnore = [
  {
    baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/blogs`,
    path: '/:slug',
    httpStatusCode: 404,
  },
  {
    baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/products`,
    path: '/:slug',
    httpStatusCode: 404,
  },
  {
    baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/providers`,
    path: '/:slug',
    httpStatusCode: 404,
  },
];
const getRouteLevel = route => route.match(/\//g || []).length;

const onError = curry((getStoreFn, errorManagementType, error) => {
  getStoreFn().dispatch('decrementPendingRequestCount', {
    root: true,
  });

  const baseUrl = errorUtils.extractErrorBaseUrl(error);
  const path = errorUtils.extractErrorPath(error);
  const httpStatusCode = errorUtils.extractErrorHttpStatusCode(error);

  const routeToIgnore = routesToIgnore.find(rti => (
    rti.httpStatusCode === httpStatusCode
    && rti.baseUrl === baseUrl
    && getRouteLevel(rti.path) === getRouteLevel(path)
  ));

  if (routeToIgnore == null) {
    switch (errorManagementType) {
      case 'errorHandling':
        getStoreFn().dispatch(
          'errorHandling/setErrorInfos',
          {
            message: errorUtils.extractErrorMessage(error),
            httpStatusCode,
            appCode: errorUtils.extractErrorAppCode(error),
          },
          {
            root: true,
          }
        );
        break;
      case 'notification':
      default:
        getStoreFn().dispatch(
          'notification/displayNotification',
          {
            title: 'Erreur !',
            message: errorUtils.extractErrorMessage(error),
            type: 'error',
          },
          {
            root: true,
          }
        );
        break;
    }
  }
});

const onRequestSuccess = getStoreFn => () => {
  getStoreFn().dispatch('incrementPendingRequestCount', {
    root: true,
  });
};

const onResponseSuccess = getStoreFn => () => {
  getStoreFn().dispatch('decrementPendingRequestCount', {
    root: true,
  });
};

class HttpUtils {
  constructor() {
    // Making _store a private property
    // There's no way of doing it natively yet...
    let _store;

    this.setStore = (store) => {
      _store = store;
    };

    this.getStore = () => {
      if (_store == null) {
        throw new Error('A store should be bound. Make sure to call `setStore()` first.');
      }

      return _store;
    };
  }

  createRequester(options, errorManagementType = 'notification') {
    const getStore = this.getStore.bind(this);

    const optionsWithHandlers = {
      ...options,
      headers: {
        'accept-language': window.processEnv.VUE_APP_DEFAULT_LANGUAGE,
        wsVersion: window.processEnv.VUE_APP_WS_VERSION || 'LIVE',
        'x-boires-auth-token': localStorage.token || sessionStorage.token,
      },
      onRequestSuccess: onRequestSuccess(getStore),
      onResponseSuccess: onResponseSuccess(getStore),
      onError: onError(getStore, errorManagementType),
    };

    return httpUtils.createRequester(optionsWithHandlers);
  }
}

export default new HttpUtils();
